import { Experiment } from '@amplitude/experiment-js-client';
import { AppConfig } from 'config';

// Initialize experiment lazily to avoid timing issues
let experiment: ReturnType<typeof Experiment.initializeWithAmplitudeAnalytics> | null = null;

const getExperimentInstance = () => {
  if (!experiment && AppConfig.REACT_APP_AMPLITUDE_KEY) {
    try {
      experiment = Experiment.initializeWithAmplitudeAnalytics('client-GgZa4BIbZNKvh8HZLuQySJjeyWpqejCV', {
        // Add timeout configuration to prevent hanging
        fetchTimeoutMillis: 2000,
        retryFetchOnFailure: false,
      });
    } catch (error) {
      console.warn('Failed to initialize Amplitude Experiment:', error);
    }
  }
  return experiment;
};

interface AmplitudeUser {
  user_id?: string;
  [key: string]: unknown;
}

export const useGetAmplitudeExperimentInfo = () => {
  const getAmplitudeUser = async (user: AmplitudeUser) => {
    const exp = getExperimentInstance();
    if (!exp) return {};

    try {
      const response = await exp.fetch(user);
      return response;
    } catch (error) {
      console.warn('Failed to fetch Amplitude user:', error);
      return {};
    }
  };

  const getUpgradeButtonVariant = async (): Promise<string> => {
    const exp = getExperimentInstance();
    if (!exp) return 'control';

    try {
      const response = await exp.variant('upgrade_button_variant', { value: 'control' });
      return response.value || 'control';
    } catch (error) {
      console.error('Error fetching upgrade button variant:', error);
      return 'control';
    }
  };

  const getOnboardingVariant = async () => {
    const exp = getExperimentInstance();
    if (!exp) return 'onboarding-on';

    try {
      const response = await exp.variant('onboarding', { value: 'onboarding-on' });
      return response.value || 'onboarding-on';
    } catch (error) {
      console.warn('Error fetching onboarding variant:', error);
      return 'onboarding-on';
    }
  };

  return { getAmplitudeUser, getUpgradeButtonVariant, getOnboardingVariant };
};
